<template>
    <div>
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate
                                 color="primary"
                                 :size="70"
                                 :width="7"></v-progress-circular>
        </v-overlay>
        <v-card>
            <v-data-table dense class="elevation-1"
                          :headers="headers"
                          :items="luItems"
                          :search="search"
                          item-key="id"
                          :loading="isLoading"
                          :items-per-page="20">

                <template v-slot:[`item.id`]="{ item }">
                    {{ item.id}}

                </template>
                <template v-slot:[`item.description`]="{ item }">
                    {{ item.description}}

                </template>

                <template v-slot:top>
                    <v-toolbar flat>
                        <v-text-field v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            class="ml-1"
                            single-line
                            hide-details
                            clearable
                        />
                        <v-btn class="text-xs ml-2" v-on:click="refresh" color="primary">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog"
                                  max-width="500px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary"
                                       dark
                                       class="mb-2"
                                       v-bind="attrs"
                                       v-on="on">
                                    Add
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-form v-model="isValid">
                                            <v-row>
                                                <v-alert width="100%" class="pr-2 pl-2" v-if="errorMessage" type="error"> {{ errorMessage }}</v-alert>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <span v-if="maxSize==2">
                                                        <v-text-field v-model="editedItem.id"
                                                                      label="Id*" :disabled="editedIndex != -1"
                                                                      :rules="[(v) => !!v || 'ID is required',(v) =>v.length <= 2 || 'Limited to 2 chars.', ]" />
                                                    </span>
                                                    <span v-if="maxSize==3">
                                                        <v-text-field v-model="editedItem.id"
                                                                      label="Id*" :disabled="editedIndex != -1"
                                                                      :rules="[(v) => !!v || 'ID is required',(v) =>v.length <= 3 || 'Limited to 3 chars.',]" />
                                                    </span>

                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editedItem.description" label="Description*"
                                                                  :rules="[(v) => !!v || 'Description is required',(v) =>v.length <= 50 || 'Limited to 50 chars.',]" />
                                                </v-col>

                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1"
                                           text
                                           @click="close">
                                        Cancel
                                    </v-btn>
                                    <v-btn color="blue darken-1"
                                           text
                                           :disabled="!isValid"
                                           @click="save">
                                        Add/Update
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDelete" max-width="500px">
                            <v-card>
                                <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small
                            class="mr-2"
                            @click="editItem(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small v-if="item.canDelete"
                            @click="deleteItem(item)">
                        mdi-delete
                    </v-icon>
                </template>

            </v-data-table>

        </v-card>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import lookupsService from "@/services/admin/lookupsService";
import { LookupInfo } from "@/types/admin/Lookup";

export default Vue.extend({
    name: "BasicLUMaintenance",
    data: function () {
        return {
            tab: null,
            luItems: [] as LookupInfo[],
            tdialog: false,
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: "ID", align: "left", value: "id" },
                { text: "Description", align: "left", value: "description" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                id: "",
                description: "",
                canDelete: true,
            },
            defaultItem: {
                id: "",
                description: "",
                canDelete: true,
            },
            errorMessage: "",
            isValid: true,
            search: "",
            isLoading: false,

        };
    },
    created: function () {
        this.refresh();
    },
    methods: {
        refresh: function () {
            if (this.luType == 'Eyes') {
                this.$data.isLoading = true;
                lookupsService.getEyeColors().then((res: LookupInfo[]) => {
                    this.luItems = res;
                    this.$data.isLoading = false;
                });

            }
            else if (this.luType == 'Body') {
                this.$data.isLoading = true;
                lookupsService.getBodyColors().then((res: LookupInfo[]) => {
                    this.luItems = res;
                    this.$data.isLoading = false;
                });
            }
            else if (this.luType == 'Trim') {
                this.$data.isLoading = true;
                lookupsService.getTrimColors().then((res: LookupInfo[]) => {
                    this.luItems = res;
                    this.$data.isLoading = false;
                });
            }
            else if (this.luType == 'Breeds') {
                this.$data.isLoading = true;
                lookupsService.getBreeds().then((res: LookupInfo[]) => {
                    this.luItems = res;
                    this.$data.isLoading = false;
                });
            }
        },
        editItem(item: LookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        deleteItem(item: LookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm() {
            this.errorMessage = "";
            if (this.editedItem.canDelete) {
                if (this.luType == 'Eyes') {
                    lookupsService.deleteEyeColor(this.editedItem.id).then((res) => {
                        if (!res.success) {
                            this.errorMessage = "Unable to delete color"
                            return;
                        }

                    }).catch((e: any) => {
                        this.errorMessage = "Unable to delete the color.";
                        return;
                    });
                }
                else if (this.luType == 'Body') {
                    lookupsService.deleteBodyColor(this.editedItem.id).then((res) => {
                        if (!res.success) {
                            this.errorMessage = "Unable to delete color"
                            return;
                        }

                    }).catch((e: any) => {
                        this.errorMessage = "Unable to delete the color.";
                        return;
                    });

                }
                else if (this.luType == 'Trim') {
                    lookupsService.deleteTrimColor(this.editedItem.id).then((res) => {
                        if (!res.success) {
                            this.errorMessage = "Unable to delete color"
                            return;
                        }

                    }).catch((e: any) => {
                        this.errorMessage = "Unable to delete the color.";
                        return;
                    });

                }
                else if (this.luType == 'Breeds') {
                    lookupsService.deleteBreed(this.editedItem.id).then((res) => {
                        if (!res.success) {
                            this.errorMessage = "Unable to delete breed"
                            return;
                        }

                    }).catch((e: any) => {
                        this.errorMessage = "Unable to delete the breed.";
                        return;
                    });

                }


                this.luItems.splice(this.editedIndex, 1);

            }
            this.closeDelete();
        },

        close() {
            this.errorMessage = "";
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save() {
            this.errorMessage = "";
            if (this.editedItem.id.trim().length == 0 || this.editedItem.description.trim().length == 0) {
                this.errorMessage = "Please enter valid values."
                return;
            }
            if (!/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/i.test(this.editedItem.id)) {
                this.errorMessage = "Please enter valid values."
                return;
            }
            this.editedItem.id = this.editedItem.id.trim().toUpperCase();
            if (this.editedItem.id.includes(' ')) {
                this.errorMessage = "Please enter valid values."
                return;
            }


            this.editedItem.description = this.editedItem.description.trim().toUpperCase();
            if (this.luItems) {
                if (this.editedIndex == -1) {
                    var exists = this.luItems.find((x: any) => x.id == this.editedItem.id);
                    if (exists != null) {
                        this.errorMessage = "This Id already exists.";
                        return;
                    }
                }


            }
            if (this.luType == 'Eyes') {
                lookupsService.editEyeColor(this.editedItem).then((res: any) => {
                    if (res.success) {
                        if (this.editedIndex > -1) {
                            Object.assign(this.luItems[this.editedIndex], this.editedItem)

                        }
                        else {
                            if (this.luItems) {
                                this.luItems.unshift(this.editedItem);

                            }
                        }
                        this.close();
                    }
                    else {
                        this.errorMessage = "Unable to edit the eye color.";
                        return;
                    }
                });
            }
            else if (this.luType == 'Body') {
                lookupsService.editBodyColor(this.editedItem).then((res: any) => {
                    if (res.success) {
                        if (this.editedIndex > -1) {
                            Object.assign(this.luItems[this.editedIndex], this.editedItem)

                        }
                        else {
                            if (this.luItems) {
                                this.luItems.unshift(this.editedItem);

                            }
                        }
                        this.close();
                    }
                    else {
                        this.errorMessage = "Unable to edit the body color.";
                        return;
                    }
                });
            }
            else if (this.luType == 'Trim') {
                lookupsService.editTrimColor(this.editedItem).then((res: any) => {
                    if (res.success) {
                        if (this.editedIndex > -1) {
                            Object.assign(this.luItems[this.editedIndex], this.editedItem)

                        }
                        else {
                            if (this.luItems) {
                                this.luItems.unshift(this.editedItem);

                            }
                        }
                        this.close();
                    }
                    else {
                        this.errorMessage = "Unable to edit the trim color.";
                        return;
                    }
                });
            }
            else if (this.luType == 'Breeds') {
                lookupsService.editBreed(this.editedItem).then((res: any) => {
                    if (res.success) {
                        if (this.editedIndex > -1) {
                            Object.assign(this.luItems[this.editedIndex], this.editedItem)

                        }
                        else {
                            if (this.luItems) {
                                this.luItems.unshift(this.editedItem);

                            }
                        }
                        this.close();
                    }
                    else {
                        this.errorMessage = "Unable to edit the breed.";
                        return;
                    }
                });
            }

        },
    },
    computed: {
        formTitle() {
            return this.$data.editedIndex === -1 ? "New Item" : "Edit Item";
        },
    },
    watch: {
        dialog(val) {
            val || this.close()
        },
        dialogDelete(val) {
            val || this.closeDelete()
        },
    },
    props: {
        luType: { type: String },
        maxSize: { type: String },
    },
});
</script>